export default __webpack_public_path__ + "static/media/black_crystal_horn.571aee5e.png";